export default __webpack_public_path__ + "static/media/Pen.3a47b0fa.svg";